export default __webpack_public_path__ + "static/media/ic_money.ccc29d72.svg";